<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import authorityRequirementAPI from "../../../services/standards/authorityRequirement/authorityRequirementAPI";
import authorityRequirementMatrixAPI from "../../../services/standards/authorityRequirement/authorityRequirementMatrixAPI";
import { dateFormat } from "@/utils/helpers/format";

const BUCKET = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/7.1.4";

/**
 * 7.1.4 Implementación de medidas y acciones correctivas de autoridades y ARL — hub del ítem:
 * (1) formatos en blanco descargables (formato de registro + matriz),
 * (2) Registro por requerimiento online firmable (SST-FT-029),
 * (3) Matriz de seguimiento online versionable + dashboard → PDF firmado (SST-FT-030).
 */
export default {
  page: {
    title: "7.1.4 Medidas y acciones correctivas de autoridades y ARL",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal },
  data() {
    return {
      title: "7.1.4 Implementar Medidas y Acciones Correctivas de Autoridades y ARL",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "Medidas y acciones correctivas de autoridades y ARL", active: true },
      ],
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      records: [],
      matrices: [],
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(60) // 60 = 7.1.4
        .then((response) => { this.itemData = response; this.loading = false; })
        .catch((error) => { console.log(error); this.loading = false; });
    },
    allowAccess() {
      try {
        const item = this.itemData;
        if (!item) return false;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) { console.log(e); return false; }
    },
    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 60) // 60 = 7.1.4
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response && response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => console.log(error));
    },
    async changeItemStatus(itemStatus) {
      try {
        await newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 60, status: itemStatus });
        Swal.fire({ title: "¡Éxito!", text: "¡Se ha cambiado el estado del ítem con éxito!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
        setTimeout(() => window.location.reload(), 2000);
      } catch (error) {
        Swal.fire({ title: "¡Error!", text: "¡No se ha actualizado el estado del ítem!", icon: "error", confirmButtonClass: "btn btn-confirm mt-2" });
        setTimeout(() => window.location.reload(), 2000);
        console.error(error);
      }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const permissions = this.$store.state.auth.info.permissions;
      const enabled = permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    dateConvert(date) { return date ? dateFormat(date) : ""; },
    statusBadgeClass(s) { return s === "signed" ? "badge-success" : "badge-secondary"; },
    statusText(s) { return s === "signed" ? "Firmado" : "Borrador"; },

    descargarFormato(tipo) {
      const file = tipo === "matriz"
        ? "MATRIZ_SEGUIMIENTO_REQUERIMIENTOS_7.1.4.xlsx"
        : "FORMATO_IMPLEMENTACION_MEDIDAS_AUTORIDADES_ARL_7.1.4.docx";
      window.open(`${BUCKET}/${file}`);
    },

    // ── Registros por requerimiento ──
    getRecords() {
      authorityRequirementAPI.getAll(this.companyID, 1)
        .then((r) => { this.records = (r && r.List && r.List.data) ? r.List.data : []; })
        .catch((e) => console.log(e));
    },
    newRecord() { this.$router.push({ path: `/forms/estandares/${this.companyID}/requerimiento-autoridad` }); },
    editRecord(id) { this.$router.push({ path: `/forms/estandares/${this.companyID}/requerimiento-autoridad/${id}` }); },
    downloadRecordPdf(id) { window.open(authorityRequirementAPI.pdfUrl(id), "_blank"); },
    deleteRecord(id) {
      Swal.fire({ title: "¿Eliminar registro?", icon: "warning", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar" }).then((res) => {
        if (!res.value) return;
        authorityRequirementAPI.delete(id).then(() => {
          Swal.fire({ title: "Eliminado", icon: "success", timer: 1200, showConfirmButton: false });
          this.getRecords();
        }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
      });
    },

    // ── Matriz de seguimiento ──
    getMatrices() {
      authorityRequirementMatrixAPI.getAll(this.companyID, 1)
        .then((r) => { this.matrices = (r && r.List && r.List.data) ? r.List.data : []; })
        .catch((e) => console.log(e));
    },
    newMatrix() { this.$router.push({ path: `/forms/estandares/${this.companyID}/requerimiento-matriz` }); },
    editMatrix(id) { this.$router.push({ path: `/forms/estandares/${this.companyID}/requerimiento-matriz/${id}` }); },
    downloadMatrixPdf(id) { window.open(authorityRequirementMatrixAPI.pdfUrl(id), "_blank"); },
    cloneMatrix(id) {
      Swal.fire({ title: "¿Crear nueva versión?", text: "Se clonarán los requerimientos de esta versión en una nueva editable.", icon: "question", showCancelButton: true, confirmButtonText: "Crear versión", cancelButtonText: "Cancelar" }).then((res) => {
        if (!res.value) return;
        authorityRequirementMatrixAPI.cloneVersion(id).then((r) => { if (r && r.id) this.editMatrix(r.id); })
          .catch((e) => { console.log(e); Swal.fire("Error", "No se pudo clonar", "error"); });
      });
    },
    deleteMatrix(id) {
      Swal.fire({ title: "¿Eliminar versión?", text: "Se eliminará la matriz y sus requerimientos.", icon: "warning", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar" }).then((res) => {
        if (!res.value) return;
        authorityRequirementMatrixAPI.delete(id).then(() => {
          Swal.fire({ title: "Eliminada", icon: "success", timer: 1200, showConfirmButton: false });
          this.getMatrices();
        }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
      });
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getRecords();
    this.getMatrices();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <!-- Descripción + estado + descargas -->
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Implementa, hace seguimiento y cierra las medidas y acciones correctivas derivadas de los
                      requerimientos emitidos por autoridades competentes (Ministerio de Trabajo, Secretaría de Salud,
                      etc.) y por la ARL, evidenciando su cumplimiento ante los entes de control.
                    </p>
                    <p class="text-justify">
                      Diligencia cada <b>requerimiento</b> en un registro detallado (firmable) y consolida el
                      <b>seguimiento</b> en la matriz versionable, o descarga los formatos en blanco.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="col-12 text-right m-b-0 d-flex justify-content-end flex-wrap align-items-center">
                <button type="button" class="btn btn-outline-primary mx-1" @click="descargarFormato('formato')">
                  <i class="bx bx-download"></i> Formato de registro (Word)
                </button>
                <button type="button" class="btn btn-outline-primary mx-1" @click="descargarFormato('matriz')">
                  <i class="bx bx-download"></i> Matriz de seguimiento (Excel)
                </button>
              </div>
            </div>
          </div>

          <!-- Registros por requerimiento (online, firmable) -->
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="mb-0">Registros por requerimiento (online)</h5>
                  <p class="text-muted small mb-1">Un registro detallado y firmable por cada requerimiento de autoridad/ARL.</p>
                </div>
                <button :disabled="!allowAccess() || !getRole('Crear')" @click="newRecord" class="btn btn-primary btn-sm">
                  <i class="mdi mdi-plus"></i> Nuevo requerimiento
                </button>
              </div>
              <div class="table-responsive mt-1">
                <table class="table table-sm border-bottom table-striped">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Fecha</th>
                      <th class="text-center align-middle">Entidad</th>
                      <th class="text-center align-middle">N° oficio</th>
                      <th class="text-center align-middle">Estado</th>
                      <th class="text-center align-middle">Firma</th>
                      <th class="text-center align-middle">PDF</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!records.length"><td colspan="7" class="text-center text-muted">No hay requerimientos registrados.</td></tr>
                    <tr v-for="r in records" :key="r.id">
                      <td class="text-center align-middle">{{ r.fecha_requerimiento ? dateConvert(r.fecha_requerimiento) : (r.fecha ? dateConvert(r.fecha) : '') }}</td>
                      <td class="text-center align-middle">{{ r.entidad }}</td>
                      <td class="text-center align-middle">{{ r.oficio }}</td>
                      <td class="text-center align-middle">{{ r.estado }}</td>
                      <td class="text-center align-middle"><span class="badge" :class="statusBadgeClass(r.workflow_status)">{{ statusText(r.workflow_status) }}</span></td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;" type="button" @click="downloadRecordPdf(r.id)" title="Descargar PDF">
                          <i class="mdi mdi-file-pdf-box" style="font-size:1.3rem; color:#c0392b;"></i>
                        </button>
                      </td>
                      <td class="text-center align-middle">
                        <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                          <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                          <b-dropdown-item :disabled="!getRole('Editar')" @click="editRecord(r.id)">{{ r.workflow_status === 'signed' ? 'Ver' : 'Editar' }}</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deleteRecord(r.id)">Eliminar</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Matriz de seguimiento (online, versionable + dashboard, firmable) -->
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="mb-0">Matriz de seguimiento (online)</h5>
                  <p class="text-muted small mb-1">Consolidado versionable de requerimientos con dashboard y firma del encargado.</p>
                </div>
                <button :disabled="!allowAccess() || !getRole('Crear')" @click="newMatrix" class="btn btn-primary btn-sm">
                  <i class="mdi mdi-plus"></i> Nueva matriz
                </button>
              </div>
              <div class="table-responsive mt-1">
                <table class="table table-sm border-bottom table-striped">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Versión</th>
                      <th class="text-center align-middle">Fecha</th>
                      <th class="text-center align-middle">Requerimientos</th>
                      <th class="text-center align-middle">Estado</th>
                      <th class="text-center align-middle">PDF</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!matrices.length"><td colspan="6" class="text-center text-muted">No hay matrices registradas.</td></tr>
                    <tr v-for="m in matrices" :key="m.id">
                      <td class="text-center align-middle font-weight-bold">{{ m.version }}</td>
                      <td class="text-center align-middle">{{ m.fecha ? dateConvert(m.fecha) : '' }}</td>
                      <td class="text-center align-middle">{{ m.rows_count }}</td>
                      <td class="text-center align-middle"><span class="badge" :class="statusBadgeClass(m.workflow_status)">{{ statusText(m.workflow_status) }}</span></td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;" type="button" @click="downloadMatrixPdf(m.id)" title="Descargar PDF">
                          <i class="mdi mdi-file-pdf-box" style="font-size:1.3rem; color:#c0392b;"></i>
                        </button>
                      </td>
                      <td class="text-center align-middle">
                        <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                          <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                          <b-dropdown-item :disabled="!getRole('Editar')" @click="editMatrix(m.id)">{{ m.workflow_status === 'signed' ? 'Ver' : 'Editar' }}</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Crear')" @click="cloneMatrix(m.id)">Nueva versión (clonar)</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deleteMatrix(m.id)">Eliminar</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="text-center pt-4"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
        </div>
      </div>
    </div>
  </Layout>
</template>
